import template from "./entity-inventory-operations.html";
import "./entity-inventory-operations.less";
import { FORM_ENTITY_INVENTORY_ITEM } from "../../../../../../../routes";

export function controller($logger, api, appState, loadingService) {
	const ctrl = this;
	ctrl.inventoryOperations = [];

	ctrl.$onInit = function() {
		// type InventoryIOperation  = {
		// 	Id: number;
		// 	Record: number;
		//	Value: number
		// 	Occurred: string;
		// 	Type: {
		//		Name: string;
		//		Code: string;
		//  };
		// };

		ctrl.item = ctrl.resolve.inventoryItem;

		loadInventoryItem();
	};

	ctrl.handleClose = () => {
		ctrl.modalInstance.dismiss();
	};

	async function loadInventoryItem() {
		const loadPromise = api.get(FORM_ENTITY_INVENTORY_ITEM(appState.forms.selected.Id, ctrl.resolve.forEntity.Id, ctrl.item.Item.Id));
		const item = await loadingService.watch(loadPromise);

		ctrl.inventoryOperations = item.Operations ?? [];

		ctrl.inventoryOperations.sort((a, b) => new Date(a.Occurred) < new Date(b.Occurred) ? -1 : 1);

		return item;
	}
}

export default angular.module("vesl.components.entity-inventory-operations", [])
	.component("entityInventoryOperations", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	})
	.name;
